import React, { useCallback, useRef } from 'react'
import { Grid, Icon, Popup } from 'semantic-ui-react'
import InputField from '@commonComponents/formComponents/CustomInputField'
import DeleteIcon from '@commonComponents/deleteIcon'
import { AddBtn } from '@commonComponents/AddBtn'
import { CustomLoader } from '@commonComponents/formComponents/loader'
import CustomPopup from '@commonComponents/customPopup'
import CCDocList from '../AES_App/formSections/CCDocList'

const CCDocForm = ({
  dataSource: { id, reference, description, documentName, documentSent },
  onChange,
  onBlur,
  isLoading,
  deleteData,
  tableName,
}) => {
  const isDisabled=documentSent==="true" || false
  const popup = useRef()
  const onChangeHandler = useCallback(
    ({ target: { value, name } }) => onChange(id, tableName, { [name]: value }),
    [tableName, id, onChange]
  )

  const onBlurHandler = useCallback(
    ({ target: { value, name } }) =>
      onBlur(tableName, { [name]: value, id }),
    [tableName, id, onBlur]
  )

  const handleAttach = useCallback((fileName) => {
    onChangeHandler({ target: { name: 'documentName', value: fileName } })
    onBlurHandler({ target: { name: 'documentName', value: fileName } })
    popup.current?.closePopup()
  }, [])
  return (
    <div className='formContainer'>
      <Grid.Row>
        <Grid.Column width='3'>
          <InputField
            id={`description-${id}`}
            name='description'
            type='text'
            label='DESCRIPTION'
            value={description}
            isDisabled={isDisabled}
            clearInput={false}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>

        <Grid.Column width='3' style={{ flex: 1 }}>
          <InputField
            id={`reference-${id}`}
            name='reference'
            type='text'
            label='REF_NUMBER'
            value={reference}
            isDisabled={isDisabled}
            clearInput={false}
            onChange={onChangeHandler}
            onBlur={onBlurHandler}
          />
        </Grid.Column>
        <Grid.Column>
          <CustomPopup
            content={true}
            onClose={() => popup.current?.closePopup()}
            description={
              <CCDocList onClose={() => popup.current?.closePopup()} handleAttach={handleAttach} />
            }
            ref={popup}
            className='fileUploadPopup'
          />
          <div style={{ display: 'flex', alignItems: 'center', marginTop: '-.6rem' }}>
            <span
              style={{
                display: 'inline-block',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                textAlign: 'center',
                padding: '5px',
                width: '65%',
                marginTop: '1.3rem',
              }}
            >
              {documentName}
            </span>
            <AddBtn
              text='ATTACH DOC'
              onClick={() => popup.current?.openPopup()}
              size='mini'
              isDisabled={isDisabled}
              style={{}}
            />
            <Popup
              content={documentSent === 'true' ? 'Document Sent!' : 'Document not sent!'}
              inverted
              style={{ borderRadius: 0 }}
              trigger={
                <Icon
                  name='check circle'
                  color={documentSent === 'true' ? 'green' : 'grey'}
                  style={{ marginTop: '0.6rem', marginLeft: '.5rem' }}
                />
              }
              position='right center'
            />
          </div>
        </Grid.Column>
      </Grid.Row>
      <div className='actionbtns'>
        {isLoading && <CustomLoader style={{ position: 'fixed' }} />}
        {!isLoading && (
          <DeleteIcon onClick={() => deleteData(id, tableName)} isDisabled={isDisabled} />
        )}
      </div>
    </div>
  )
}
CCDocForm.defaultProps = {
  translate: (value) => value,
}
export default React.memo(CCDocForm)
